import React from "react";
import Table from "../../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import { Progress, InfiniteScroll, Button, dialog } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import ProfileNoticesPresenter from "./ProfileNoticesPresenter";
import FormFactory from "../../../../../../components/FormFactory";
import FileUpload from "../../../../../../components/common/FileUpload";

class ProfileNoticesPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ProfileNoticesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getCollectionName() {
    return "notices";
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  async setCount() {
    this.setState({ count: await this.presenter.setCount() });
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleViewData(object) {
    const schema = this.getSchema(this.getCollectionName());
    const excludeFieldsFather = ["title", "description"];
    const includeField = Object.keys(schema.fields).filter(
      (key) => !excludeFieldsFather.includes(key)
    );
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Submit Request Confirmation</h4>
            <hr />

            <FormFactory
              schema={schema}
              object={object}
              disabled={true}
              // onChange={this.onChange.bind(this)}
              excludeFields={includeField}
            />

            {object?.selectedFiles && object.selectedFiles.length > 0 && (
              <div className="mt-2">
                <label className="mb-2 fs-6">Documents</label>
                <FileUpload
                  // accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                  label={"Documents"}
                  disabled={true}
                  attachments={object.selectedFiles}
                />
              </div>
            )}
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Close
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <Table
                progress={loading}
                objectData={(data) => this.handleViewData(data)}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "template", "employee", "sendToAll"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default ProfileNoticesPage;
